export const currentEventFormatter = (event, filters) => {
  if ( event ) {
    return {
      id: event.id,
      color: event.eventlocation.color,
      title: event.title,
      month: filters.formatShortDate(event.startdate, {month: 'short'}),
      day: filters.formatShortDate(event.startdate, {day: 'numeric'}),
      startDate: filters.formatDate(event.startdate),
      startTime: `${filters.formatTime(event.starttime)} Uhr`,
      endDate: filters.formatDate(event.enddate),
      endTime: `${filters.formatTime(event.endtime)} Uhr`,
      price: `${event.priceperplace} CHF / Platz`,
      price_type: `${event.price_list.length?event.price_list[0].type:'0'}`,
      price_text: `${event.price_list.length?event.price_list[0].text:'Standard'}`,
      price_list: event.price_list,
      onlyPrice: parseInt(event.priceperplace),
      address: `${event.eventlocation.street}, ${event.eventlocation.postalcode} ${event.eventlocation.city}`,
      mapsLink: event.eventlocation.mapslink,
      availablePlaces: event.availableplaces,
      hasNums: event.hasnums,
      nums: event.nums,
      content: event.description
    }
  }
};
